import React from "react";
import "../Css/ArticleItemCard.css";

export class ArticleItemCard extends React.Component {
  state = {};
  constructor(props) {
    super(props);
    this.state = this.props;
    
    console.log(this.state);
  }

  render() {
    return (
      <div
        className="ui segment aic__root"
        onClick={(e) => {
          window.onbeforeunload = null;
          const path = "/article/" + this.state.aid;
          //在新視窗顯示文章
          window.open(path, '_blank').focus(); 
        }}
      >
        {/* 預覽圖 */}
        <div className="aic__img-container">
          <img
            src={this.state.thumbNail?.src}
            style={{
              width: this.state.thumbNail.scale,
              height: this.state.thumbNail.scale,
              top: this.state.thumbNail.top,
              left: this.state.thumbNail.left,
            }}
          ></img>
        </div>

        <hr className="ui divider" />

        <p className="aic__title">{this.state.title}</p>
        <p className="aic__meta">{this.state.meta}</p>
      </div>
    );
  }
}

ArticleItemCard.defaultProps = {
  title: "title",
  meta: "meta tags",
  date: "",
  aid: "",
  path:"",
  thumbNail: {
    src: "https://react.semantic-ui.com/images/wireframe/image.png",
    //src: "https://p2.bahamut.com.tw/B/2KU/68/dcd67eb852a58364306d65054f1e17k5.JPG",
    scale: "188%",
    left: 0,
    top: 0,
  },
};
